import { Fragment, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import { RewardReferralRole } from '../../../../models/RewardStore';
import {
  LoadMoreSpinner,
  ScrollArrows,
  SvgIcon,
  UserCell,
  UserCellProps,
} from '../../../Molecules';

import styles from './WebStoreReferralUserListTemplate.module.css';

export type WebStoreReferralUserListTemplateProps = {
  totalReferralUserCount: number;
  rewardReferralRole: RewardReferralRole | undefined;
  data: UserCellProps[];
  hasCursor: boolean;
  loadMoreItems: () => void;
};

export const WebStoreReferralUserListTemplate = memo(
  ({
    totalReferralUserCount,
    rewardReferralRole,
    data,
    hasCursor,
    loadMoreItems,
  }: WebStoreReferralUserListTemplateProps) => {
    const { t } = useTranslation();

    const title =
      rewardReferralRole === RewardReferralRole.Partner
        ? t('Referred Partners')
        : rewardReferralRole === RewardReferralRole.Distributor
        ? t('Referred Distributor')
        : t('Referred Users (Tier 2)');

    return (
      <div className={styles.webStoreReferralReward}>
        {totalReferralUserCount > 10 && <ScrollArrows />}
        <div className={styles.centeredContainer}>
          <div
            className={styles.listTitle}
          >{`${totalReferralUserCount} ${title}`}</div>
          <div className={styles.listView}>
            {data.length === 0 ? (
              <div className={styles.emptyContainer}>
                <SvgIcon
                  name={SVGIconType.DoublePerson}
                  className={styles.emptyReferralIcon}
                />
                <div className={styles.emptyReferralText}>
                  {t('No Users Referred')}
                </div>
              </div>
            ) : (
              data.map((item, index) => (
                <Fragment key={index}>
                  {index != 0 && <div className={styles.cellSpace} />}
                  <UserCell key={index} {...item} />
                </Fragment>
              ))
            )}
          </div>
          {hasCursor && (
            <LoadMoreSpinner
              hasCursor={hasCursor}
              loadMoreItems={loadMoreItems}
            />
          )}
        </div>
      </div>
    );
  },
);
